// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j6Ej","question":"styles_question__1VfBt","description":"styles_description__DooGz"};